/**
 * Marks an element (and everything nested inside it) as carrying customer
 * data. Mixpanel still records the click, dead click, rage click or scroll —
 * only the element's text and attributes are left out.
 */
export const SENSITIVE_CLASS_NAME = 'mp-sensitive';
